import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import api from '../../core';
import { API_VERSION } from '../constants';
import { useApp } from '../../../context';
import { ReportAPI } from '../../../common/constants';

export const useListReport = (url, params = {}, config, apiVersion = API_VERSION) => {
  const _params = {};
  const { companyId, rowsPerPage } = useApp();
  const [search] = useSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value) _params[key] = value;
  });

  _params['companyId'] = params?.companyId ?? companyId;
  _params['page'] = params?.page ?? +search.get('page') + 1;
  _params['locale'] = localStorage.getItem('applang');
  _params['limit'] = params?.limit ?? rowsPerPage;

  const context = useQuery(
    [url, _params],
    ({ queryKey }) => reportFetcher({ queryKey, apiVersion }),
    {
      enabled:
        config?.enabled !== undefined ? (url ? true : false) : config?.enabled,
      ...config,
    },
  );

  return context;
};

export const reportFetcher = async ({ queryKey, apiVersion }) => {
  const [url, params] = queryKey;
  return await api.get(`${ReportAPI}api/reports${apiVersion}/${url}`, {
    params: { ...params },
  });
};
